import api from "../../../../../common/dependencies/utils/Api";
import {
  CURRENT_DASHBOARD_PROFILE,
  CURRENT_DASHBOARD_ADMIN,
  ADMIN_DASHBOARD_MENTOR_APPLICATION,
  TABLELIST_MENTOR_REQUESTS,
  VIEW_APPLICATION_DATA,
  VIEW_PREDEFINED_OPTIONS,
  GUIDED_INSTRUCTIONS,
  UPDATE_APPLICATION_STATUS,
  VIEW_COUNTER_OPTIONS,
  VIEW_COUNTER_SESSIONS,
  VIEW_COUNTER_STARTUP_OPTIONS,
  VIEW_COUNTER_HOURS,
  GET_NAMES_DATA,
  SET_ADMIN_COHORT_STATUS,
  COHORT_APPLICATIONS_COUNTER,
  GET_ACTIVITY_SUMMARY_DASHBOARD,
  GET_ACTIVITY_SUMMARY_PERFORMANCE,
  GET_ACTIVITY_SUMMARY_NULL,
  GET_ACTIVITY_SUMMARY_LOW_ACTIVITY,
  ACTIVITY_SUMMARY_MENTORSHIP_COUNTS,
  ACTIVITY_SUMMARY_STARTUP_COUNTS,
  ACTIVITY_SUMMARY_MENTORSHIP_TOTAL,
  ACTIVITY_SUMMARY_MENTORSHIP_STATUS,
  ACTIVITY_SUMMARY_COHORT_COUNTS,
  DOWNLOAD_EXCEL_MENTOR,
  DOWNLOAD_EXCEL_COHORT,
  DOWNLOAD_EXCEL_STARTUP,
  DOWNLOAD_EXCEL_STARTUP_REQUEST,
  ADMIN_DASHBOARD_COHORT_GRAPH_API,
  ADMIN_DASHBOARD_MENTOR_GRAPH_API,
  ADMIN_DASHBOARD_SPOTLIGHT_LIST,
  PUBLIC_LIST_GROUP_SESSIONS
} from "../../../../../common/constants/ApplicationUrl";

export const AdminDashboardServices = {
  currentDashboardProfile() {
    return api
      .GET(`${CURRENT_DASHBOARD_PROFILE}`)
      .then((response) => {
        const { data: { responseCode, data } = {} } = response;
        if (responseCode === 200) {
          return data;
        } else {
          return Promise.reject(response.data);
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  currentDashboardAdmin() {
    return api
      .GET(`${CURRENT_DASHBOARD_ADMIN}`)
      .then((response) => {
        const { data: { responseCode, data } = {} } = response;
        if (responseCode === 200) {
          return data;
        } else {
          return Promise.reject(response.data);
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getAdminMentorApplicationList(params) {
    return api
      .POST(`${ADMIN_DASHBOARD_MENTOR_APPLICATION}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          //
          return response.data;
        } else {
          //
          //   toast.error("Invalid Username or Password");
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  adminDashCohortCounterAPI(params) {
    return api
      .POST(`${ADMIN_DASHBOARD_COHORT_GRAPH_API}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          //
          return response.data;
        } else {
          //
          //   toast.error("Invalid Username or Password");
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  publicCohortListData(params) {
    return api
      .POST(`${PUBLIC_LIST_GROUP_SESSIONS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          //
          return response.data;
        } else {
          //
          //   toast.error("Invalid Username or Password");
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  }
  ,
  adminDashMentorCounterAPI(params) {
    return api
      .POST(`${ADMIN_DASHBOARD_MENTOR_GRAPH_API}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          //
          return response.data;
        } else {
          //
          //   toast.error("Invalid Username or Password");
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getAdminMentorRequestList(params) {
    return api
      .POST(`${TABLELIST_MENTOR_REQUESTS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          //
          return response.data;
        } else {
          //
          //   toast.error("Invalid Username or Password");
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getViewApplicationData(params) {
    return api
      .POST(`${VIEW_APPLICATION_DATA}`, params)
      .then((response) => {
        //
        const { data, status } = response || {};
        if (status === 200) {
          //
          return response.data;
        } else {
          //
          //   toast.error("Invalid Username or Password");
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getPredefineOptionsList() {
    return api
      .GET(`${VIEW_PREDEFINED_OPTIONS}`)
      .then((response) => {
        const { data: { responseCode, data } = {} } = response;
        if (responseCode === 200) {
          return data;
        } else {
          return Promise.reject(response.data);
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getStepperList() {
    return api
      .GET(`${GUIDED_INSTRUCTIONS}`)
      .then((response) => {
        const { data: { responseCode, data } = {} } = response;
        if (responseCode === 200) {
          return data;
        } else {
          return Promise.reject(response.data);
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  // getCountersList() {
  //   return api
  //     .POST(`${VIEW_COUNTER_OPTIONS}`)
  //     .then((response) => {
  //       const { data: { responseCode, data } = {} } = response;
  //       if (responseCode === 200) {
  //         return data;
  //       } else {
  //         return Promise.reject(response.data);
  //       }
  //     })
  //     .catch((e) => {
  //       return Promise.reject(e);
  //     });
  // },
  getCountersList(params) {
    return api
      .POST(`${VIEW_COUNTER_OPTIONS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getCountersSessions(params) {
    return api
      .POST(`${VIEW_COUNTER_SESSIONS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getCountersHours(params) {
    return api
      .POST(`${VIEW_COUNTER_HOURS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  updateApplicationStatus(params) {
    return api
      .POST(`${UPDATE_APPLICATION_STATUS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getNamesAPI(params) {
    return api
      .POST(`${GET_NAMES_DATA}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  setAdminCohortStatus(params) {
    return api
      .POST(`${SET_ADMIN_COHORT_STATUS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getCohortApplicationCounterAPI(params) {
    return api
      .POST(`${COHORT_APPLICATIONS_COUNTER}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getActivitySummaryDashboardAPI(params) {
    return api
      .POST(`${GET_ACTIVITY_SUMMARY_DASHBOARD}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getActivitySummaryMentorshipCount(params) {
    return api
      .POST(`${ACTIVITY_SUMMARY_MENTORSHIP_COUNTS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getActivitySummaryStartupCount(params) {
    return api
      .POST(`${ACTIVITY_SUMMARY_STARTUP_COUNTS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getActivitySummaryCohortCount(params) {
    return api
      .POST(`${ACTIVITY_SUMMARY_COHORT_COUNTS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getActivitySummaryStartupTotal(params) {
    return api
      .POST(`${ACTIVITY_SUMMARY_MENTORSHIP_TOTAL}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getActivitySummaryMentorshipStatus(params) {
    return api
      .POST(`${ACTIVITY_SUMMARY_MENTORSHIP_STATUS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getActivitySummaryPerformanceAPI(params) {
    return api
      .POST(`${GET_ACTIVITY_SUMMARY_PERFORMANCE}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getActivitySummaryNullAPI(params) {
    return api
      .POST(`${GET_ACTIVITY_SUMMARY_NULL}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getActivitySummaryLowActivityAPI(params) {
    return api
      .POST(`${GET_ACTIVITY_SUMMARY_LOW_ACTIVITY}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getSpotLightList(params) {
    return api
      .POST(`${ADMIN_DASHBOARD_SPOTLIGHT_LIST}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getExcelMentor() {
    return api
      .GET(`${DOWNLOAD_EXCEL_MENTOR}`)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getExcelStartup() {
    return api
      .GET(`${DOWNLOAD_EXCEL_STARTUP}`)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getExcelStartuprRequest() {
    return api
      .GET(`${DOWNLOAD_EXCEL_STARTUP_REQUEST}`)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getExcelCohort() {
    return api
      .POST(`${DOWNLOAD_EXCEL_COHORT}`)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
};
